import { CompanyEntity } from "domain/entity/Company/CompanyEntity";
import { EMPTY_RECAL_PROPOSAL_SET_DTL_ENTITY, RecalProposalSetDtlEntity } from "domain/entity/RecalProposalSet/RecalProposalSetDtlEntity";
import { EMPTY_RECAL_PROPOSAL_SET_ENTITY, RecalProposalSetEntity } from "domain/entity/RecalProposalSet/RecalProposalSetEntity";
import { TariffRecalProposalEntity } from "domain/entity/RecalProposalSet/TariffRecalProposalEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface RecalProposalSetDropdownOptions {
    proposalNoDropdownOptions: { [key: string]: DropdownProps[] },
    companyCodeDropdownOptions: DropdownProps[],
}
export interface RecalProposalSetViewChangeState extends BaseViewChangeSate {
}

export interface RecalProposalSetModel {
    isLoading: boolean,
    isShowEditPanel: boolean,
    isAdd: boolean,
    isEdit: boolean,
    isShowDtlEditPanel: boolean,
    isShowDtlAddPanel: boolean,
    dynamicOptions: RecalProposalSetDropdownOptions,
    recalProposalSetList: RecalProposalSetEntity[],
    selectedRows: RecalProposalSetEntity[],
    updatedRows: RecalProposalSetEntity[],
    currentRow: RecalProposalSetEntity,
    currentEditRow: RecalProposalSetEntity,
    currentDtlEditRow: RecalProposalSetDtlEntity,
    selectedDtlRows: RecalProposalSetDtlEntity[],
    tempDtlRows: RecalProposalSetDtlEntity[],
    forceRefresh: boolean,
    dtlForceRefresh: boolean,
    companyList: { [key: string]: CompanyEntity[] },
    proposalList: { [key: string]: TariffRecalProposalEntity[] },
    masterState: RecalProposalSetViewChangeState,


}

export const EMPTY_RECAL_PROPOSAL_SET_MODEL: RecalProposalSetModel = {
    isLoading: false,
    isShowEditPanel: false,
    isAdd: false,
    isEdit: false,
    isShowDtlEditPanel: false,
    isShowDtlAddPanel: false,
    dynamicOptions: {
        companyCodeDropdownOptions: [],
        proposalNoDropdownOptions: {},
    },
    recalProposalSetList: [],
    selectedRows: [],
    updatedRows: [],
    currentRow: { ...EMPTY_RECAL_PROPOSAL_SET_ENTITY },
    currentEditRow: { ...EMPTY_RECAL_PROPOSAL_SET_ENTITY },
    currentDtlEditRow: { ...EMPTY_RECAL_PROPOSAL_SET_DTL_ENTITY },
    selectedDtlRows: [],
    tempDtlRows: [],
    forceRefresh: false,
    dtlForceRefresh: false,
    companyList: {},
    proposalList: {},
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    }

}